import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { discountBadgeClass, discountPercentLabel, discountSource, priceDiscountPercent } from '../utils/priceDiscount';

const CatalogDiscountBadge = ({ product }) => {
  const percent = discountPercentLabel(priceDiscountPercent(product.price, product.discountedPrice));
  if (!percent) return null;
  const source = discountSource(product);
  let explanation = 'Знижка на товар';
  if (source === 'personal') explanation = `Накопичувальна знижка: ${product.personalDiscount}% для даної категорії товару`;
  if (source === 'product') explanation = product.state === 'PREORDER' ? 'Знижка за передзамовленням' : 'Акційна знижка';

  return <OverlayTrigger placement='top' overlay={
    <Tooltip id={`catalog-discount-${product.id}`}><strong>{explanation}</strong></Tooltip>
  }>
    <span className={`badge-pill discount-badge ${discountBadgeClass(product)}`}>−{percent}%</span>
  </OverlayTrigger>;
};

export default CatalogDiscountBadge;
